import { getValueShippinggroupStatusEnum } from "@Helpers/UtilsHelper"
import { useParams } from "react-router-dom"
import useUserPermissions from "@Hooks/UseUserPermissions"
import { useContext } from "react"
import { AuthContext } from "@Context/context/AuthContext"
import { ConfigGroupOrderType } from "@Types/OrderType"
import { WebAppClientsEnum } from "@Enums/CommonEnum"
import { typeObjectGeneric } from "@Types/CommonsTypes"
import { EShippinggroupAction, EShippinggroupStatus } from "@Enums/shippinggroupEmun"
import { ResourcePermissionsEnum } from "@Enums/ResourcePermissionsEnum"
import { IOrderShippinggroup } from "@Interfaces/IOrder"
// import { ShippingTypeEnum } from "@Enums/OrderEnum"
import { useTranslation } from "react-i18next"
import { ShippingTypeEnum } from "@Enums/OrderEnum"

const useConditionalsGroupOrder = () => {
  const { type } = useParams<{ type: string }>()
  const {
    state: { user },
  } = useContext(AuthContext)

  const { t } = useTranslation()

  const typeStatus = getValueShippinggroupStatusEnum(type)

  const configGroupOrder: typeObjectGeneric<Array<ConfigGroupOrderType>> = {
    [WebAppClientsEnum.wom]: [
      {
        status: EShippinggroupStatus.package,
        action: EShippinggroupAction.packed,
        labelAction: t("LABEL_PACKED_GROUP"),
        permission: ResourcePermissionsEnum.packingGroup,
        predicate: ({ custom }: IOrderShippinggroup) => !custom?.infoElocker?.isElocker,
      },
      {
        status: EShippinggroupStatus.delivery,
        action: EShippinggroupAction.shipped,
        permission: ResourcePermissionsEnum.shippingGroup,
        predicate: ({ custom, shippingType }: IOrderShippinggroup) =>
          !custom && shippingType === ShippingTypeEnum.HD,
        labelAction: t("LABEL_SHIPPED_GROUP"),
      },
    ],
    [WebAppClientsEnum.privilege]: [
      {
        status: EShippinggroupStatus.package,
        action: EShippinggroupAction.packed,
        labelAction: t("LABEL_PACKED_GROUP"),
        permission: ResourcePermissionsEnum.packingGroup,
      },
      {
        status: EShippinggroupStatus.delivery,
        action: EShippinggroupAction.shipped,
        labelAction: t("LABEL_SHIPPED_GROUP"),
        permission: ResourcePermissionsEnum.shippingGroup,
      },
    ],
  }

  const config = configGroupOrder[user?.mainGroup.id as keyof typeof configGroupOrder]

  const statusGroup = config?.find(({ status }) => status === typeStatus)

  const { permission } = useUserPermissions({
    resources: statusGroup?.permission ? [statusGroup?.permission] : [],
  })

  return {
    canSelectMultiple: !!statusGroup && permission[statusGroup.permission],
    statusGroup,
    typeStatus: type,
  }
}

export default useConditionalsGroupOrder
